@let contactInfo = contactInfo$ | async;

<div class="tw:flex tw:content-center tw:justify-start tw:px-4 tw:pb-2">
  @if (contactInfo) {
    <ion-avatar class="tw:relative tw:h-12 tw:w-12">
      <img
        alt="Title Rep's photo"
        class="tw:object-cover tw:object-center"
        ngSrc="{{ contactInfo.photoUrl || '/assets/svg/avatar.svg' }}"
        fill
      />
    </ion-avatar>
    <span
      class="tw:h-12 tw:flex-1 tw:overflow-hidden tw:p-1 tw:pl-4 tw:text-xs tw:leading-10 tw:text-ellipsis tw:whitespace-nowrap"
    >
      {{ contactInfo.firstName }} {{ contactInfo.lastName }},
      {{ contactInfo?.company }}
    </span>
  }
</div>
